import { render, staticRenderFns } from "./ChangeDetails.vue?vue&type=template&id=b030ea0c&scoped=true"
import script from "./ChangeDetails.vue?vue&type=script&lang=js"
export * from "./ChangeDetails.vue?vue&type=script&lang=js"
import style0 from "./ChangeDetails.vue?vue&type=style&index=0&id=b030ea0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b030ea0c",
  null
  
)

export default component.exports